<template>
  <b-modal ref="vehicle-card-modal" @ok="vehicleCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.vehicles.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.registerNumber"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="registerNumber"
          :state="isRegisterNumberValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.brand"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="brand"
          :state="isBrandValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.typeVehicle"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="typeId"
          :options="typeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.countOfTanks"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="1000"
          v-model="countOfTanks"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.driver"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="driver"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.vehicles.tableColumns.supplierId"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="supplierId"
          :options="supplierOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="vehicle.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateVehiclePage",
  props: {
    vehicle: Object,
    suppliers: Array,
    globalDriverCompanies: Array,
  },
  components: {},
  data() {
    return {
      supplierOptions: [],

      registerNumber: null,
      brand: null,
      driver: null,
      typeId: null,
      countOfTanks: null,
      supplierId: null,

      isRegisterNumberValid: null,
      isBrandValid: null,
      created: null,
      updated: null
    };
  },
  computed: {
    typeOptions() {
      const typeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.azk.vehicles.typeOptions
          .length;
        i++
      ) {
        typeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.azk.vehicles
              .typeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.azk.vehicles
            .typeOptions[i].value,
        });
      }
      return typeOptions;
    },
  },
  methods: {
    async open() {
      this.registerNumber = this.vehicle.registerNumber;
      this.brand = this.vehicle.brand;
      this.driver = this.vehicle.driver;
      this.typeId = this.vehicle.typeVehicle;
      this.countOfTanks = this.vehicle.countOfTanks;
      this.supplierId = this.vehicle.supplierId;

      this.isRegisterNumberValid = null;
      this.isBrandValid = null;

      this.supplierOptions = [];

      for (let i = 0; i < this.suppliers.length; i++) {
        if (this.suppliers[i].clientId == this.vehicle.clientId) {
          this.supplierOptions.push({
            value: `${this.suppliers[i].id}-local`,
            text: this.suppliers[i].name,
          });

          if (this.suppliers[i].supplierId == this.vehicle.supplierId) {
            this.supplierId = `${this.suppliers[i].id}-local`;
          }
        }
      }

      for (let i = 0; i < this.globalDriverCompanies.length; i++) {
        this.supplierOptions.push({
            value: `${this.globalDriverCompanies[i].id}-global`,
            text: this.globalDriverCompanies[i].unit,
          });

          if (this.globalDriverCompanies[i].id == this.vehicle.globalCompanyId) {
            this.supplierId = `${this.globalDriverCompanies[i].id}-global`;
          }
      }

      this.created = utilsService.formatDateTime(new Date(this.vehicle.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.vehicle.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["vehicle-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.registerNumber) {
        this.isRegisterNumberValid = false;
        isValid = false;
      } else {
        this.isRegisterNumberValid = null;
      }

      if (!this.brand) {
        this.isBrandValid = false;
        isValid = false;
      } else {
        this.isBrandValid = null;
      }

      return isValid;
    },
    async vehicleCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      this.vehicle.registerNumber = this.registerNumber;
      this.vehicle.brand = this.brand;
      this.vehicle.driver = this.driver;
      this.vehicle.typeVehicle = parseInt(this.typeId);
      this.vehicle.countOfTanks = parseInt(this.countOfTanks);

      if (this.supplierId.includes('-local')) {
        const supplierId = parseInt(this.supplierId.replace('-local', ''));
        const supplier = this.suppliers.find(x => x.id == supplierId);

        this.vehicle.supplierId = supplier.supplierId;
        this.vehicle.globalCompanyId = 0;
      } else {
        const supplierId = parseInt(this.supplierId.replace('-global', ''));
        const globalDriverCompany = this.globalDriverCompanies.find(x => x.id == supplierId);
        this.vehicle.globalCompanyId = globalDriverCompany.id;
        this.vehicle.supplierId = 0;
      }
      
      const updateVehicleResponse = await azkService.updateVehicle(this.vehicle);

      if (
        updateVehicleResponse.isSuccess &&
        updateVehicleResponse.data &&
        updateVehicleResponse.data.countInsertedRows == 1
      ) {
        this.$emit("vehicleUpdatedSuccessEvent", this.vehicle);
      } else {
        this.$emit("vehicleUpdatedFailEvent");
      }
    },
  },
};
</script>
